// extracted by mini-css-extract-plugin
export var adCard = "_p6-8";
export var adCardBorder = "_p6-5";
export var arbiterButtonIcon = "_p6-p";
export var buttonIcon = "_p6-o";
export var container = "_p6-e";
export var copyButton = "_p6-m";
export var darkGrey = "_p6-u";
export var deliveryDate = "_p6-2";
export var divider = "_p6-n";
export var editModeWrapper = "_p6-7";
export var empty = "_p6-a";
export var errorIcon = "_p6-d";
export var filledCircle = "_p6-4";
export var fulfillmentFooter = "_p6-j";
export var grey = "_p6-s";
export var header = "_p6-i";
export var headerWrapper = "_p6-h";
export var highlighted = "_p6-6";
export var historyEntry = "_p6-3";
export var mobileColumn = "_p6-v";
export var mobileColumnReverse = "_p6-w";
export var orderDetailsContainer = "_p6-g";
export var orderMetadata = "_p6-l";
export var orderMetadataWrapper = "_p6-k";
export var packagesContainer = "_p6-b";
export var product = "_p6-y";
export var productImage = "_p6-z";
export var productInfo = "_p6-x";
export var productTitle = "_p6-10";
export var strikethrough = "_p6-t";
export var tinyText = "_p6-r";
export var title = "_p6-9";
export var trackerCard = "_p6-1";
export var trackerCardWrapper = "_p6-0";
export var trackingContainer = "_p6-f";
export var trackingTitle = "_p6-c";
export var xTinyText = "_p6-q";